<script setup lang="ts">
  import { Button } from "@ui-kit";

  const { is_loading } = defineProps<{ is_loading: boolean }>();
  const emit = defineEmits<{ (e: "click:ack"): void }>();
</script>

<template>
  <div class="order-card-created-footer">
    <Button @click="emit('click:ack')" :isLoading="is_loading" data-testid="order-ack-btn">
      {{ $t("Взять в работу") }}
      <template #iconAfter>
        <IconArrowRight />
      </template>
    </Button>
  </div>
</template>

<style scoped>
  .order-card-created-footer {
    padding: 16px;
    border-radius: 16px 16px 0 0;
    background-color: var(--sf-base-background-white);
    position: sticky;
    bottom: 0;

    & :deep(.button) {
      width: 100%;
    }

    & :deep(.icon) {
      stroke: var(--sf-base-icon-white);
    }
  }
</style>
